// Vibration API (haptic feedback) helper for tactile confirmation on mobile devices

export const triggerHaptic = (type: 'light' | 'medium' | 'heavy' | 'success' | 'warning' = 'light') => {
  if (typeof window !== 'undefined' && window.navigator && typeof window.navigator.vibrate === 'function') {
    try {
      switch (type) {
        case 'light':
          window.navigator.vibrate(15);
          break;
        case 'medium':
          window.navigator.vibrate(35);
          break;
        case 'heavy':
          window.navigator.vibrate(60);
          break;
        case 'success':
          window.navigator.vibrate([25, 40, 25, 40, 50]);
          break;
        case 'warning':
          window.navigator.vibrate([50, 30, 50]);
          break;
        default:
          window.navigator.vibrate(15);
      }
    } catch (e) {
      // Ignore vibration errors if blocked by browser policy or device
    }
  }
};
